const initProvinceAtGlance = ( container ) => {
	window.addEventListener(  'cga:site:at:glance:available', ( ev ) => {
		if ( typeof ev.detail.id !== 'undefined' ) {
			container.innerHTML = ev.detail.content.rendered;
			const animateNumberEvent = new CustomEvent( 'cga:site:animate:number:need:render', { detail: container } );
			window.dispatchEvent( animateNumberEvent );
		}
	});
};

const initProvinceKeyStat = ( container ) => {
	window.addEventListener(  'cga:site:key:stat:available', ( ev ) => {
		if ( typeof ev.detail.id !== 'undefined' ) {
			container.innerHTML = ev.detail.content.rendered;
			const animateNumberEvent = new CustomEvent( 'cga:site:animate:number:need:render', { detail: container } );
			window.dispatchEvent( animateNumberEvent );
		}
	});
};

const initMemberList = ( container ) => {
	window.addEventListener(  'cga:site:members:list:available', ( ev ) => {
		if ( typeof ev.detail.data !== 'undefined' ) {
			const cga_sliders_container = container.querySelector( '.cga-sliders-container' );
			if ( cga_sliders_container !== null ) {
				const slider_key = cga_sliders_container.dataset.sliderkey;
				const slider_id = parseInt( cga_sliders_container.dataset.sliderid );
				if ( typeof window.cga_sliders[ slider_key ] !== 'undefined' ) {
					// Remove the old slider
					const slider_key_id = slider_key.replace( 'cga_slider_', '' );
					cga_sliders_container.classList.remove( `cga_slider_${slider_key_id}`, `swiper-cga_slider_${slider_key_id}`)
					window.resetCgaSlider( cga_sliders_container, slider_key );
					// Update the slider contents
					cga_sliders_container.innerHTML = ev.detail.data.join( ' ' );
					// Init new slider
					const items = cga_sliders_container.querySelectorAll( '.swiper-slide' );
					cga_sliders_container.classList.add( 'slider-initiated' );
					const a_var = `swiper_option_${slider_id}`;
					window.initCgaSlider( 
						cga_sliders_container,
						items, 
						window[ a_var ] 
					);
				}
			}
		}
	});

};

const initProvinceDynamicContent = () => {
	let containers;
	containers = document.querySelectorAll( '.province-key-stat-at-glance-container' );
	if ( containers.length > 0 ) {
		containers.forEach( container => {
			initProvinceAtGlance( container );
		});
	}

	containers = document.querySelectorAll( '.province-key-stat-container' );
	if ( containers.length > 0 ) {
		containers.forEach( container => {
			initProvinceKeyStat( container );
		});
	}

	containers = document.querySelectorAll( '.members-list-container' );
	if ( containers.length > 0 ) {
		containers.forEach( container => {
			initMemberList( container );
		});
	}
};

const initProvincialProfiles = () => {
	initProvinceDynamicContent();
};

export { initProvincialProfiles };